import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobilModalComponent } from './mobil-modal.component';
import { MainPipe } from 'src/app/common/mainpipe.module';
import { AktifButtonModule } from '../../atoms/button/aktif-button.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [MobilModalComponent],
  imports: [CommonModule, MainPipe, AktifButtonModule, FormsModule],
  exports: [MobilModalComponent],
})
export class MobilModalModule {
  getComponent() {
    return MobilModalComponent;
  }
}
